import { useEffect, useState } from "react";
import styles from "./landing-page-user.module.css";
import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { PageLoadingIndicator } from "admin/shared-components/page-loading-indicator";
import { LandingPageTwo } from "landing-pages/landing-page-two/landing-page-two";
import { LandingPageThree } from "landing-pages/landing-page-three/landing-page-three";
import { useCollectionStore } from "entity-store/collections-store/use-collection-store";
import { TemplateCollection } from "PosterEditor/model/template-collection";
import { ThreeDot } from "react-loading-indicators";
import { LandingPageFour } from "landing-pages/landing-page-four/landing-page-four";

interface LandingPageUserProps {}

export const LandingPageUser = (props: LandingPageUserProps) => {
  const { role } = useAuthContext();
  const [collection, setCollection] = useState<
    TemplateCollection | undefined
  >();

  const { loadCollectionByID } = useCollectionStore();

  useEffect(() => {
    loadCollectionByID("8725e8ae-df7a-45bc-b789-a0741fa65bfc").then(
      setCollection ?? undefined
    );
  }, []);

  if (collection === undefined) {
    return <PageLoadingIndicator />;
  }

  return <LandingPageFour />;
};
